import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "../components/ScrollToTop";
import { StudentProvider } from "../context/StudentContext";

const MainLayout = () => {
  return (
    <>
      <StudentProvider>
        <ScrollToTop />
        <Header />
        <Outlet />
        <Footer />
      </StudentProvider>
    </>
  );
};

export default MainLayout;
